export default __webpack_public_path__ + "static/api.url-e965e9258b25cefec756ecc3acd2b30c.svg";